import api from '@/utils/api'

export function getMrt(params) {
  return api.get('activity/v1/mrt', { params: params })
}

export function rankComent(params) {
  return api.post('activity/v1/mrt/rankComment', params)
}

export function barrage(params) {
  return api.post('activity/v1/mrt/barrage', params)
}

export function getBarrages(params) {
  return api.get('activity/v1/mrt/barrages', { params: params })
}

export function getSummerParty(params) {
  return api.get('activity/v1/mrt/sp', { params: params })
}
